<template>
  <div id="app" :class="$i18n.locale">
    <RwvNavMenu/>
    <div class="container">
      <RwvHeader />
      <router-view></router-view>
      <RwvFooter />
    </div>
  </div>
</template>

<script>
  import RwvHeader from "@/components/Header";
  import RwvNavMenu from "@/components/NavMenu";
  import RwvFooter from "@/components/Footer";
  export default {
    name: "App",
    components: {
      RwvHeader,
      RwvNavMenu,
      RwvFooter
    },
    mounted() {
    this.maj_partner();
    this.get_notifications();// test notifications avec le rendu initial ... 
    },
    watch: {
      $route(to, from) {
        this.maj_partner();
        this.get_infos_cli();
        this.get_notifications();
      }
    },
  };
</script>